// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"3fdb9f8d","317":"bab3f139","888":"ac62b93e"}[chunkId] + ".chunk.js";
};